module.exports = __webpack_public_path__ + "static/media/requested-friend.35254a9b.svg";